import { mutations } from "./mutations";
import { getters } from "./getters";
import { actions } from "./actions";
import { MainState } from "./state";

const defaultState: MainState = {
  isLoggedIn: null,
  token: "",
  isLoggedInUser:{},
  logInError: false,
  userProfile: null,
  notifications: [],
  myLastProject: null,
  userList: [],
  refreshControl: null,
  allIndexes: [],
  mobaProjects: [],
  hero_skin: {},
  taskLogs: [],
  staff_info: {
    ChnName: "",
    DeptNameString: "",
    PositionName: "",
    EngName: "",
    Timestamp: "",
    WorkPlaceID: "",
  },
};

export const mainModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
